
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<section class=\"c-talk\">\n  <!-- 取消底部返回按钮 -->\n  <!-- <div class=\"c-talk__back\"></div> -->\n  <div class=\"c-talk__hold\"></div>\n  <div class=\"c-talk__input\"><span>")
    ; __append(escape(desc))
    ; __append("</span></div>\n  ")
    ;  if(window.location.href.indexOf('__isUser=true') < 0) { 
    ; __append("\n    <div class=\"c-talk__gift\"></div>\n  ")
    ;  } 
    ; __append("\n  <div class=\"c-talk__collect\"></div>\n  <div class=\"c-talk__share\"></div>\n</section>\n<div class=\"c-talk__clear\"></div>")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/modules/miniInput/main.ejs
// module id = 629
// module chunks = 0